module.exports = __webpack_public_path__ + "media/images/people/boy-1-0409dbf7844cf37de420502f2e513a63.webp";